module.exports = __webpack_public_path__ + "static/media/service-3.93f71b17.jpg";